import React, {useState} from 'react';
import {ScrollView, Dimensions, View, Text, StyleSheet} from 'react-native';
import {Button, Input} from 'react-native-elements';
import {FaComment} from 'react-icons/fa';
import HomeHeader from '../../components/HomeHeader';
import {useLinkTo} from '@react-navigation/native';
import {sendReplyToComplaint} from '../../network/Network';
import Emitter from '../../components/Emitter';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

export default function FileReplyToComplaintScreen(props) {
  
  const linkTo = useLinkTo();
  
  const [input, setInput] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isDisplayError, setIsDisplayError] = useState(false);

  const readAllErrors = (message) => {
    let errors = '';
    Object.keys(message).forEach((key, index) => {
      message[key].forEach((error) => {
        errors = errors + error + '\n';
      });
    });
    return errors;
  };
  
  const onSubmitPress = () => {
    setLoading(true);
    if (input != null && input.length > 6) {
      sendReplyToComplaint(props.route.params.id, input)
        .then((reply) => {
          if (reply.success && (reply.status == 200 || reply.status == 201)) {
            setLoading(false);
            Emitter.emit('crmload', true);
            linkTo('/customers/crm');
          } else {
            setLoading(false);
            setErrorMessage(readAllErrors(reply.data.message));
            setIsDisplayError(true);
            setTimeout(() => {
              setIsDisplayError(false);
            }, 3000);
          }
        })
        .catch((r) => {
          console.log(r);
          setLoading(false);
          setErrorMessage('Error, please try again');
          setIsDisplayError(true);
          setTimeout(() => {
            setIsDisplayError(false);
          }, 3000);
        });
    } else {
      setLoading(false);
      setErrorMessage('Complaint should contain atleast 6 letters');
      setIsDisplayError(true);
      setTimeout(() => {
        setIsDisplayError(false);
      }, 3000);
    }
  };

  return (
    <View style={styles.viewStyle}>
      <HomeHeader navigation={props.navigation} />
      <ScrollView
        keyboardShouldPersistTaps="handled"
        style={styles.container}>
        <View style={styles.content}>
          {
            isDisplayError && (
              <View style={{ backgroundColor: 'white', padding: 16, borderRadius: 8, marginHorizontal: 8, marginVertical: 32 }}>
                <Text>{errorMessage}</Text>
              </View>
            )
          }
          <Input
            multiline={true}
            numberOfLines={10}
            placeholder="Write your Reply here(minimum 6 letters)"
            leftIcon={<FaComment color="white" />}
            style={{color: 'white', alignSelf: 'center'}}
            value={input}
            onChangeText={(value) => setInput(value)}
          />
          <Button
            title="Submit"
            buttonStyle={{backgroundColor: '#e10808', paddingHorizontal: 16}}
            onPress={onSubmitPress}
            loading={loading}
            raised
            containerStyle={{ margin: 16 }}
          />
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT
  },
  indicatorStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  container: {
    flex: 1
  },
  content:{
    width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 2,
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
  }
});
